import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTonConnectUI, useTonAddress } from '@tonconnect/ui-react';
import { Sheet } from './Sheet.tsx';

/**
 * Кошелёк в шапке — свой, а не готовая кнопка TON Connect.
 *
 * Причина не в красоте: готовая кнопка приносит свои шрифты, свои цвета и
 * свой английский, и в шапке, собранной по макету, выглядит наклейкой с
 * чужого приложения. Сама логика подключения при этом остаётся библиотечной —
 * мы только зовём её модальное окно.
 *
 * Адрес показываем в человеческом виде (UQ…), а не сырым: сырой нельзя ни
 * прочитать вслух, ни сверить глазами с кошельком.
 */
export function WalletButton() {
  const { t } = useTranslation();
  const [tonConnectUI] = useTonConnectUI();
  const friendly = useTonAddress(true);
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  if (friendly.length === 0) {
    return (
      <button
        className="chip"
        style={{ background: 'var(--lime)', color: 'var(--lime-ink)', border: 0, cursor: 'pointer' }}
        onClick={() => void tonConnectUI.openModal()}
      >
        {t('wallet.connect')}
      </button>
    );
  }

  const short = `${friendly.slice(0, 4)}…${friendly.slice(-4)}`;

  return (
    <>
      <button
        className="chip chip-flat"
        style={{ border: '1px solid var(--line)', cursor: 'pointer', color: 'var(--ink)' }}
        onClick={() => setOpen(true)}
      >
        {short}
      </button>

      {open && (
        <Sheet
          title={t('wallet.title')}
          confirmLabel={copied ? t('wallet.copied') : t('wallet.copy')}
          onClose={() => setOpen(false)}
          onConfirm={() => {
            void navigator.clipboard?.writeText(friendly).then(() => setCopied(true));
          }}
        >
          <span className="mono" style={{ fontSize: 12, overflowWrap: 'anywhere' }}>{friendly}</span>
          <button
            className="btn btn-ghost"
            onClick={() => {
              setOpen(false);
              void tonConnectUI.disconnect();
            }}
          >
            {t('wallet.disconnect')}
          </button>
        </Sheet>
      )}
    </>
  );
}
